import { render } from "./ResumeTasks.vue?vue&type=template&id=72077ca0"
import script from "./ResumeTasks.vue?vue&type=script&lang=js"
export * from "./ResumeTasks.vue?vue&type=script&lang=js"

import "./ResumeTasks.vue?vue&type=style&index=0&id=72077ca0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__